<template>
  <div>

    <a-card :bordered="false" :title="this.title">
      <div>
        <a-menu v-model="current" mode="horizontal">
          <a-menu-item @click="handleClick"  key="OrderFlag">{{$t('message.lzdOutboundViewDetail.title.orderStatus')}}</a-menu-item>
          <a-menu-item @click="handleClick" key="BasicFlag" > {{$t('message.lzdOutboundViewDetail.title.basicInformation')}}  </a-menu-item>
          <a-menu-item @click="handleClick" key="SellerFlag" > {{$t('message.lzdOutboundViewDetail.title.sellerInformation')}} </a-menu-item>
          <a-menu-item @click="handleClick" key="SkuFlag" >{{$t('message.lzdOutboundViewDetail.title.SKU')}} </a-menu-item>
        </a-menu>
      </div>
    </a-card>
    <br>

    <a-card :bordered="false" id="OrderFlag" :title="$t('message.lzdOutboundViewDetail.title.orderStatus')">
      <a-steps progress-dot :current="this.currentNode" class="a-step-container">
        <template v-for="lzdnode in processNodes">
          <a-step :title="lzdnode.statusName" :description="lzdnode.finishTime"/>
        </template>
      </a-steps>
    </a-card>

    <br>
    <a-card :bordered="false" id="BasicFlag" :title="$t('message.lzdOutboundViewDetail.title.basicInformation')">
      <a-descriptions>
        <a-descriptions-item :label="$t('message.lzdOutboundViewDetail.title.outboundOrderCode')">
          {{this.purchaseOrderDetail.orderCode}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.lzdOutboundViewDetail.title.inLbxOrderCode')">
          {{this.purchaseOrderDetail.attributes.inLbxOrderCode}}
        </a-descriptions-item>

        <a-descriptions-item :label="$t('message.lzdOutboundViewDetail.title.userNick')">
         {{this.purchaseOrderDetail.userInfo.userNick}}
        </a-descriptions-item>

        <a-descriptions-item :label="$t('message.lzdOutboundViewDetail.title.ioTypeName')">
          {{this.purchaseOrderDetail.attributes.ioTypeName}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.lzdOutboundViewDetail.title.orderStatusName')">
          {{this.purchaseOrderDetail.attributes.orderStatusName}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.lzdOutboundViewDetail.title.deliverTypeName')">
          {{this.purchaseOrderDetail.attributes.deliverTypeName}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.lzdOutboundViewDetail.title.estimateTimeStr')">
          {{this.purchaseOrderDetail.attributes.estimateTimeStr}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.lzdOutboundViewDetail.title.warehouseName')">
          {{this.purchaseOrderDetail.receiverInfoDTO.name}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.lzdOutboundViewDetail.title.address')">
          {{this.purchaseOrderDetail.receiverInfoDTO.address}}
        </a-descriptions-item>
      </a-descriptions>
    </a-card>

    <a-card :bordered="false" id="SellerFlag" :title="$t('message.lzdOutboundViewDetail.title.sellerInformation')">
      <a-descriptions>

        <a-descriptions-item :label="$t('message.lzdOutboundViewDetail.title.sellerName')">
          {{this.purchaseOrderDetail.senderInfoDTO.name}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.lzdOutboundViewDetail.title.mobile')">
          {{this.purchaseOrderDetail.senderInfoDTO.mobile}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.lzdOutboundViewDetail.title.sellerAddress')">
          {{this.purchaseOrderDetail.senderInfoDTO.address}}
        </a-descriptions-item>

      </a-descriptions>
    </a-card>

    <a-card :bordered="false" id="SkuFlag" :title="$t('message.lzdOutboundViewDetail.title.SKU')">
      <a-table :columns="columns" :rowKey="rowKey" :dataSource="dataSource"   :pagination="pagination" :loading="loading"
               :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      >
      </a-table>
    </a-card>

  </div>
</template>

<script>

import {InboundApi} from '../../js/InboundApi'
import request from '../../utils/request'

export default {
  computed:{
    columns () {
      return [
        {
          title: this.$t('message.lzdInboundDetail.lzdItemTable.scItemCode'),
          width: 250,
          fixed: 'left',
          dataIndex: 'scItemCode'
        },
        {
          title: this.$t('message.lzdInboundDetail.lzdItemTable.scItemId'),
          width: 150,
          dataIndex: 'scItemId'
        },
        {
          title: this.$t('message.lzdInboundDetail.lzdItemTable.sellerSku'),
          dataIndex: 'sellerSku'

        },
        {
          title: this.$t('message.lzdInboundDetail.lzdItemTable.scItemName'),
          dataIndex: 'scItemName'
        },
        {
          title: this.$t('message.lzdInboundDetail.lzdItemTable.itemRequested'),
          width: 100,
          dataIndex: 'itemRequested'
        },
        {
          title: this.$t('message.lzdInboundDetail.lzdItemTable.goodsBarcode'),
          dataIndex: 'goodsBarcode'
        },
        {
          title: this.$t('message.lzdInboundDetail.lzdItemTable.itemCompleted'),
          width: 50,
          dataIndex: 'itemCompleted'
        }, {
          title: this.$t('message.lzdInboundDetail.lzdItemTable.orderItemStatus'),
          dataIndex: 'orderItemStatus'
        }
      ]
    }
  },
  data () {
    return {
      processNodes: [],
      purchaseOrderNo: '',
      userId: '',
      title: '',
      currentNode: 0,
      purchaseOrderDetail: null,
      purchaseOrderItems: null,
      pagination: {
        defaultPageSize: 10,
        current: 1,
        pageSize: 10,
        total: 0,
        onChange: current => {
          // 切换分页时的回调，
          this.pagination.current = current
          console.log('change current=', this.pagination.current)
        }
      },
      rowKey: 'id',
      loading: true,
      dataSource: this.dataSource,
      selectedRowKeys: [], // Check here to configure the default column,
    }
  },
  created () {
    const purchaseLineData = this.$route.query.purchaseLineData
    this.purchaseOrderNo = purchaseLineData.purchaseOrderNo
    this.userId = purchaseLineData.userId
    this.title = '采购单编号:' + this.purchaseOrderNo + '(平台)'
    this.queryProcessNode(this.purchaseOrderNo)
    this.queryLazadaPurchaseDetail(this.purchaseOrderNo)
  },
  mounted () {
  },
  methods: {
    onChange (date, dateString) {
    },
    queryProcessNode (purchaseOrderNo) {
      request({
        url: InboundApi.InboundFromUrl.queryLazadaProcessNodes,
        method: 'get',
        params: {
          purchaseOrderNo: purchaseOrderNo
        }
      }).then(response => {
        console.log(response.data.model)
        this.processNodes = response.data.model
        var nodeNum = 0
        this.processNodes.some(function (node) {
          nodeNum = nodeNum + 1
        })
        this.currentNode = nodeNum
        console.log(this.currentNode)
      })
    },
    queryLazadaPurchaseDetail (purchaseOrderNo) {
      request({
        url: InboundApi.InboundFromUrl.queryLzdPurchaseOrderDetail,
        method: 'get',
        params: {
          purchaseOrderNo: purchaseOrderNo,
          platform: 2,
          userId: this.userId
        }
      }).then(response => {
        this.purchaseOrderDetail = response.data.model
        this.getPurchaseItemsData(this.purchaseOrderDetail)
      })
    },
    getPurchaseItemsData (purchaseOrderDetail) {
      const itemDTOList = purchaseOrderDetail.itemDTOList
      // 遍历item集合
      var itemData = {}
      var items = []
      var arrayIndex = 0
      itemDTOList.some(function (node) {
        // 每次都滞空
        itemData = {}
        itemData.scItemCode = node.scItemInfo.scItemCode
        itemData.scItemId = node.scItemInfo.scItemId
        if (node.attributes.sellerSkuList != 'null') {
          itemData.sellerSku = node.attributes.sellerSkuList
        }
        itemData.scItemName = node.scItemInfo.scItemName
        itemData.itemRequested = node.planQuantity
        itemData.goodsBarcode = node.scItemInfo.goodsBarcode
        itemData.isShelfLifeMgmt = node.attributes.isShelfLifeMgmt
        itemData.isSerialNumberMgmt = node.attributes.isSerialNumberMgmt
        itemData.itemCompleted = node.attributes.itemCompleted
        itemData.orderItemStatus = node.attributes.orderItemStatus
        items.push(itemData)
        arrayIndex++
      })
      this.loading = true
      this.dataSource = items
      const pagination = { ...this.pagination }
      // 获取数组大小
      pagination.total = arrayIndex + 1
      this.pagination = pagination
      this.loading = false
    },
    // 表格选择事件
    onSelectChange (selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
    },
    handleClick (e) {
      console.log(e.key)
      var selector = '#' + e.key
      document.querySelector(selector).scrollIntoView(true, {behavior: 'instant', block: 'start'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/icp/LazadaOutboundDetail.vue